import React, { useEffect, useState } from "react";
import styled from "styled-components";
import parse from "html-react-parser";
import Visitor from "../../components/layouts/Visitor";
import Image from "../../components/parts/Image";
import Text from "../../components/parts/Text";
import Divider from "../../components/parts/Divider";
import LinkButton from "../../components/parts/LinkButton";
import HeaderOne from "../../components/parts/HeaderOne";
import HeaderTwo from "../../components/parts/HeaderTwo";
import { GetPublicCafeNote200Response } from "../../../api/v1";
import { api } from "../../../api";
import Tag from "../../components/parts/Tag";
import Slider from "react-slick";
import UserHead from "../../config/UserHead";
import LinkText from "../../components/parts/LinkText";

const PublicCafeNoteStyle = styled.article`
  background: white;
  border-radius: 25px;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    padding: 20px 10px;
    margin: 30px 10px;
  }
`;

const PublicCafeNoteHeadStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 20px;
`;

const ShopImagesStyle = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-wrap: wrap;

    img {
      margin-right: 0;
      width: calc(50% - 5px);
    }
  }
`;

const SlickShopImagesStyle = styled.div`
  margin-bottom: 40px;
`;

const ShopCardsSliderStyle = styled(Slider)`
  .slick-list {
    margin-right: -9px;
    padding-bottom: 20px;
  }

  .slick-slide > div {
    padding: 0 10px 10px 0;
  }
`;

const PublisherLinkTextStyle = styled(LinkText)`
  font-weight: bold;
  text-decoration: underline;
`;

const PublicCafeNote: React.FC = () => {
  const settings = {
    adaptiveHeight: true,
    arrows: false,
    autoplay: false,
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  };
  const cafeNoteId = Number(location.pathname.split("/")[3]);
  const [cafeNote, setCafeNote] = useState<GetPublicCafeNote200Response>();

  useEffect(() => {
    api.getPublicCafeNote(cafeNoteId).then((response) => {
      setCafeNote(response.data);
    });
  }, []);

  if (!cafeNote) return;

  return (
    <Visitor>
      <UserHead title="カフェノート" />
      <PublicCafeNoteStyle>
        <PublicCafeNoteHeadStyle>
          <Tag>{cafeNote.isPublic ? "一般公開中" : "非公開"}</Tag>
          <LinkButton href={`/shops/${cafeNote.shopId}`}>店舗ページ</LinkButton>
        </PublicCafeNoteHeadStyle>
        <PublisherLinkTextStyle
          href={`/user/public-profile/${cafeNote.username}`}
        >
          書いた人：{cafeNote.username}
        </PublisherLinkTextStyle>
        <HeaderOne>{cafeNote.title || "タイトル未設定"}</HeaderOne>
        <Divider mt="20px" mb="20px" />
        {cafeNote.images.length <= 3 ? (
          <ShopImagesStyle>
            {cafeNote.images.map((shop, index) => {
              return <Image key={index} src={shop.url} alt="店舗画像" />;
            })}
          </ShopImagesStyle>
        ) : (
          <SlickShopImagesStyle>
            <ShopCardsSliderStyle {...settings}>
              {cafeNote.images.map((shop, index) => {
                return (
                  <Image
                    key={index}
                    src={shop.url}
                    width="100%"
                    alt="店舗画像"
                  />
                );
              })}
            </ShopCardsSliderStyle>
          </SlickShopImagesStyle>
        )}
        <section>
          <HeaderTwo>店舗名</HeaderTwo>
          <Divider mb="10px" />
          <Text mb="20px">
            {cafeNote.shop ? cafeNote.shop.name : "店舗未選択"}
          </Text>
        </section>
        <section>
          <HeaderTwo>日付</HeaderTwo>
          <Divider mb="10px" />
          <Text mb="20px">{cafeNote.visitingDate}</Text>
        </section>
        <section>
          <HeaderTwo>ノート</HeaderTwo>
          <Divider mb="10px" />
          {parse(cafeNote.body)}
        </section>
      </PublicCafeNoteStyle>
    </Visitor>
  );
};
export default PublicCafeNote;
